import React from 'react'
import classnames from 'classnames'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'

import feathers from './feathers'

import './normalize.css';
import './App.css';

import Header from './components/Header'
import Blog from './components/Blog'
import About from './components/About'
import Login from './components/Login'
import NotFound from './components/NotFound'

import Projects from './components/Projects'
import ProjectHeader from './components/Projects/ProjectHeader'

const App = (props) => {
  // Super obvious, but no one does this because they're out of it:
  const { className } = props;

  return (
    <Router {...props} app={feathers} className={classnames('App', className)}>
      <div className="main">
        <Switch>
          <Route path="/projects" component={ProjectHeader}/>
          <Route path="*" component={Header}/>
        </Switch>

        <div className="content">
          <Switch>
            <Route path="/" exact component={Blog}/>
            <Redirect from="/blog" to="/"/>
            <Route path="/about" component={About}/>
            <Route path="/projects" component={Projects}/>
            <Route path="/login" component={Login}/>
            <Route path="*" component={NotFound}/>
          </Switch>
        </div>
      </div>
    </Router>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js